class ScreenNavigatorEvents { }

// Events that are triggered when screens are added/removed from the stage
ScreenNavigatorEvents.ADDED_TO_STAGE = "ADDED_TO_STAGE";
ScreenNavigatorEvents.REMOVED_FROM_STAGE = "REMOVED_FROM_STAGE";

export default ScreenNavigatorEvents;